export const DEFAULT = 'default';
export const SAVING = 'saving';

export const SAVING_LABEL = 'Saving...';
export const SAVED_LABEL = 'Saved';
